module.exports = __webpack_public_path__ + "img/BPE_logo.b7fb1279.png";